import styled from 'styled-components';

const VideoStyle = styled.div`
	--videoPadTop: 50%;

	--playPauseButtonSize: var(--sp16x);

	--defaultVideoIconSize: var(--sp12x);

	&.video-cont {
		position: relative;
		width: 100%;
		padding-top: var(--videoPadTop);
		cursor: pointer;

		video {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			object-fit: cover;
			object-position: center;
			z-index: 1;
		}

		&.video-background {
			&:before {
				content: '';
				position: absolute;
				width: 100%;
				height: 100%;
				inset: 0;
				background-color: var(--black);
				opacity: 0.4;
				z-index: 2;
			}
		}

		.video-icon {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: var(--playPauseButtonSize);
			color: var(--white);
			z-index: 7;
			pointer-events: none;
		}
	}

	.icon-container {
		--iconSize: var(--defaultVideoIconSize);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--playPauseButtonSize: var(--sp12x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--playPauseButtonSize: var(--sp11x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--playPauseButtonSize: var(--sp10x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--playPauseButtonSize: var(--sp9x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--playPauseButtonSize: var(--sp6x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--playPauseButtonSize: var(--sp5x);
		--defaultVideoIconSize: var(--sp10x);
	}
`;

export default VideoStyle;
